<template lang='pug'>
  .view-container
    .canvas-container
      template(v-if='canvas')
      canvas#canvas(ref='canvas')
    .interface-container
      .content-container.text-container
        .title Instructions
        .instructions {{instructions}}
      .progress-bar
        .bar(:style="{width:((step+1)/steps*100)+'%'}")
      .content-container.buttons-container
        .button(@click='back') {{step===0?"Cancel":"Back"}}
        .step {{step + 1}} of {{steps}}
        .button.accent(@click='next') {{step===steps-1?"Done":"Next"}}
</template>

<script>
const animals = ["mouse","impala","moose","shrew","fox","lemur","iguana","buffalo","walrus","dingo","parakeet","cat","pig","mynah bird","porcupine","horse","armadillo","cow","skunk","muskrat","grizzly bear","lamb","lizard","polar bear","ape","mole","crocodile","gazelle","boar","platypus","goat","cheetah","elephant","tiger","mongoose","raccoon","baboon","hamster","jaguar","toad","oryx","dog","gorilla","lynx","ferret","lion","bull","guinea pig","salamander","tapir","llama","monkey","deer","fish","rabbit","bear","dromedary","mink","donkey","hedgehog","aardvark","badger","gopher","prairie dog","ground hog","leopard","wildcat","opossum","ram","seal","snake","koala","crow","chameleon","zebra","elk","wolf","warthog","beaver","jackal","woodchuck","reptile","wolverine","whale","porpoise","newt","hog","mule","alpaca","mandrill","hippopotamus","panther","yak","gila monster","ox","chimpanzee","antelope","silver fox","coyote","bat"]
const adjectives = ["lacking","scattered","wary","rare","left","daily","pastoral","glistening","cooperative","moldy","sufficient","rapid","one","accidental","fanatical","busy","numberless","complex","enchanted","evanescent","forgetful","open","ethereal","happy","momentous","futuristic","periodic","tense","remarkable","military","slow","loose","disastrous","nonstop","nervous","wandering","breakable","smelly","flippant","omniscient","unwieldy","hurried","axiomatic","selfish","boring","eatable","unsightly","yellow","phobic","nutritious","round","excited","energetic","cold","far-flung","abject","invincible","juvenile","spotless","first","wonderful","two","functional","evasive","fabulous","heavenly","small","wretched","devilish","early","violet","waiting","feigned","environmental","tedious","endurable","magical","similar","grubby","animated","modern","selective","abrasive","craven","abounding","unknown","vacuous","charming","famous","ambiguous","quirky","unable","panicky","powerful","plastic","jumpy","instinctive","parched","tearful","unhealthy"]
function randomName(){
  let adjective = adjectives[Math.floor(Math.random() * adjectives.length)]
  let animal = animals[Math.floor(Math.random() * animals.length)]

  return [
    adjective[0].toUpperCase(),
    adjective.substring(1),
    " ",
    animal[0].toUpperCase(),
    animal.substring(1),
  ].join("")
}
const nubRadius = 10
const addedHitArea = 10
const lineWidth = 5

const nubRadiusSmall = 2
const lineWidthSmall = 2

const eyeFocus = 0.283234

const defaultEyeOuterRadius = 0.2

export default {
  data(){
    return {
      id: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
      name: randomName(),

      ready: false,
      looping: true,
      step: 0,
      steps: 5,

      dragHanlder: null,

      mouse: {
        click: {x: 0, y: 0},
        current: {x: 0, y: 0},
        down: false,
        dragging: false,
      },

      scale: 1,
      translate: {
        x: 0.5, y: 0.5,
      },
      smoothScale: 1,
      smoothTranslate: {
        x: 0.5, y: 0.5,
      },
      eyeRect: {
        a: {x: 0.3, y: 0.35},
        b: {x: 1-0.3, y: 0.55},
      },
      leftEyeOuter: {
        x: 0, y: 0,
        a: {x: 0.25, y: 0.25},
        b: {x: 0.75, y: 0.75},
      },
      leftEyeInner: {
        x: 0, y: 0,
      },
      rightEyeOuter: {
        x: 0, y: 0,
        a: {x: 0.25, y: 0.25},
        b: {x: 0.75, y: 0.75},
      },
      rightEyeInner: {
        x: 0, y: 0,
      },
    }
  },
  methods: {
    getNumbers(){
      const {canvas, context} = this

      let photoScale = Math.max(canvas.width, canvas.height) / Math.min(this.photo.width, this.photo.height)
      photoScale *= this.smoothScale

      let photoTranslate = {
        x: this.photo.width * photoScale * (this.smoothTranslate.x),
        y: this.photo.height * photoScale * (this.smoothTranslate.y),
      }

      let photoOrigin = {
        x: canvas.width / 2 - photoTranslate.x,
        y: canvas.height / 2 - photoTranslate.y,
      }

      return {photoScale, photoOrigin, photoTranslate}
    },
    loop(){
      const {canvas, context} = this

      const smoothing = 15
      this.smoothScale += (this.scale - this.smoothScale) / smoothing
      this.smoothTranslate.x += (this.translate.x - this.smoothTranslate.x) / smoothing
      this.smoothTranslate.y += (this.translate.y - this.smoothTranslate.y) / smoothing

      let {photoScale, photoOrigin} = this.getNumbers()

      canvas.width = canvas.parentElement.offsetWidth
      canvas.height = canvas.parentElement.offsetHeight

      context.drawImage(
        this.photo, 
        photoOrigin.x,
        photoOrigin.y, 
        this.photo.width * photoScale,
        this.photo.height * photoScale)

      context.lineWidth = lineWidth
      context.strokeStyle = this.theme.ac1
      context.fillStyle = this.theme.ac1c

      /*********************************************************************/
      /*********************************************************************/
      /*********************************************************************/
      /****************************STEP 1***********************************/
      /*********************************************************************/
      /*********************************************************************/
      /*********************************************************************/
      let points = []

      if(this.step === 0){
        this.scale = 1
        this.translate.x = 0.5
        this.translate.y = 0.5
        let a = this.r2a(this.eyeRect.a.x, this.eyeRect.a.y)
        let b = this.r2a(this.eyeRect.b.x, this.eyeRect.b.y)

        context.strokeRect(a.x, a.y, b.x - a.x, b.y - a.y)

        if(this.dragHanlder){
          context.lineWidth = lineWidthSmall
          context.beginPath()
          context.moveTo(a.x, (a.y + b.y) / 2)
          context.lineTo(b.x, (a.y + b.y) / 2)

          context.moveTo(a.x + (b.x - a.x) * eyeFocus, a.y)
          context.lineTo(a.x + (b.x - a.x) * eyeFocus, b.y)

          context.moveTo(b.x - (b.x - a.x) * eyeFocus, a.y)
          context.lineTo(b.x - (b.x - a.x) * eyeFocus, b.y)

          context.stroke()
          context.lineWidth = lineWidth
        }
        
        points = [
          {
            x: a.x, y: a.y,
            dragHanlder(x, y){
              let relative = this.a2r(x, y)
              this.eyeRect.a.x = relative.x
              this.eyeRect.a.y = relative.y
              this.setDefaultCircleSelections()
            },
          },
          {
            x: b.x, y: a.y,
            dragHanlder(x, y){
              let relative = this.a2r(x, y)
              this.eyeRect.b.x = relative.x
              this.eyeRect.a.y = relative.y
              this.setDefaultCircleSelections()
            },
          },
          {
            x: a.x, y: b.y,
            dragHanlder(x, y){
              let relative = this.a2r(x, y)
              this.eyeRect.a.x = relative.x
              this.eyeRect.b.y = relative.y
              this.setDefaultCircleSelections()
            },
          },
          {
            x: b.x, y: b.y,
            dragHanlder(x, y){
              let relative = this.a2r(x, y)
              this.eyeRect.b.x = relative.x
              this.eyeRect.b.y = relative.y
              this.setDefaultCircleSelections()
            },
          },
        ]

        
      }

      /*********************************************************************/
      /*********************************************************************/
      /*********************************************************************/
      /****************************STEP 2-5*********************************/
      /*********************************************************************/
      /*********************************************************************/
      /*********************************************************************/

      if([1, 2, 3, 4].includes(this.step)){
        // Focus on the correct eye
        if(this.step === 1){
          // Right outer
          let eyeRect = this.eyeRectNormalized

          this.scale = 1/Math.max(eyeRect.width/2, eyeRect.height)

          this.translate.x = eyeRect.x + eyeRect.width * eyeFocus
          this.translate.y = eyeRect.y + eyeRect.height/2
        }

        const limbusZoom = (1/2.5)

        if(this.step === 2){
          // Right inner
          let eyeRect = this.eyeRectNormalized
          let rdx = this.rightEyeOuter.a.x - this.rightEyeOuter.x
          let rdy = this.rightEyeOuter.a.y - this.rightEyeOuter.y
          let radius = limbusZoom/Math.sqrt(rdx * rdx + rdy * rdy)

          this.scale = radius

          this.translate.x = this.rightEyeOuter.x
          this.translate.y = this.rightEyeOuter.y
        }

        if(this.step === 3){
          // Left outer
          let eyeRect = this.eyeRectNormalized

          this.scale = 1/Math.max(eyeRect.width/2, eyeRect.height)

          this.translate.x = eyeRect.x + eyeRect.width * (1 - eyeFocus)
          this.translate.y = eyeRect.y + eyeRect.height/2
        }

        if(this.step === 4){
          // Left outer
          let eyeRect = this.eyeRectNormalized
          let rdx = this.leftEyeOuter.a.x - this.leftEyeOuter.x
          let rdy = this.leftEyeOuter.a.y - this.leftEyeOuter.y
          let radius = limbusZoom/Math.sqrt(rdx * rdx + rdy * rdy)

          this.scale = radius

          this.translate.x = this.leftEyeOuter.x
          this.translate.y = this.leftEyeOuter.y
        }

        let targetRing = ({
          1: this.rightEyeOuter,
          2: this.rightEyeInner,
          3: this.leftEyeOuter,
          4: this.leftEyeInner,
        })[this.step]

        // Draw
        let center = this.r2a(targetRing.x, targetRing.y)

        function recenterBrilliance(){
          if(this.step === 1){
            this.rightEyeInner.x = this.rightEyeOuter.x
            this.rightEyeInner.y = this.rightEyeOuter.y
          } else if(this.step === 3){
            this.leftEyeInner.x = this.leftEyeOuter.x
            this.leftEyeInner.y = this.leftEyeOuter.y
          }
        }
        recenterBrilliance = recenterBrilliance.bind(this)

        points = [
          {
            x: center.x,
            y: center.y,
            dragHanlder(x, y){
              let relative = this.a2r(x, y)
              let offset = {
                x: relative.x - targetRing.x,
                y: relative.y - targetRing.y,
              }
              let points = [targetRing, targetRing.a, targetRing.b].filter(p => p)
              for(let point of points){
                point.x += offset.x
                point.y += offset.y
              }

              recenterBrilliance()
            },
          },
        ]

        if([1, 3].includes(this.step)){
          let a = this.r2a(targetRing.a.x, targetRing.a.y)
          let b = this.r2a(targetRing.b.x, targetRing.b.y)
          let rdx = a.x - center.x
          let rdy = a.y - center.y
          let radius = Math.sqrt(rdx * rdx + rdy * rdy) 
          context.beginPath()
          context.arc(center.x, center.y, radius, 0, Math.PI * 2)
          context.stroke() 
          
          for(let [m, n] of [[targetRing.a, targetRing.b], [targetRing.b, targetRing.a]]){
            let absolute = this.r2a(m.x, m.y)
            points.push({
              x: absolute.x,
              y: absolute.y,
              dragHanlder(x, y){
                let relative = this.a2r(x, y)
                m.x = relative.x
                m.y = relative.y
                targetRing.x = (m.x + n.x) / 2
                targetRing.y = (m.y + n.y) / 2
                recenterBrilliance()
              }
            })
          }
        }
      }

      for(let point of points){
        context.beginPath()
        context.arc(point.x, point.y, nubRadius, 0, Math.PI * 2)
        context.fill()
        context.stroke()

        if(this.mouse.dragging && !this.dragHanlder){
          let mousePoint = this.mouse.current
          let dx = point.x - mousePoint.x             
          let dy = point.y - mousePoint.y
          let dist = Math.sqrt(dx * dx + dy * dy)
          if(dist < nubRadius + addedHitArea){
            this.dragHanlder = point.dragHanlder
            break
          }             
        }
      }

      if(this.looping) requestAnimationFrame(this.loop)
    },
    r2a(x, y){ // Relative to Absolute
      let {photoScale, photoOrigin} = this.getNumbers()
      return {
        x: photoOrigin.x + (x * photoScale * this.photo.width),
        y: photoOrigin.y + (y * photoScale * this.photo.height),
      } 
    },
    a2r(x, y){ // Absolute to relative
      let {photoScale, photoOrigin, photoTranslate} = this.getNumbers()
      return {
        x: (photoTranslate.x - this.canvas.width / 2 + x) / (this.photo.width * photoScale),
        y: (photoTranslate.y - this.canvas.height / 2 + y) / (this.photo.height * photoScale),
      }
    },
    setDefaultCircleSelections(){
      let eyeRect = this.eyeRectNormalized

      let rightX = eyeRect.x + eyeRect.width * eyeFocus
      let leftX = eyeRect.x + eyeRect.width * (1- eyeFocus)
      let y = eyeRect.y + eyeRect.height/2
      let minDim = Math.min(eyeRect.width, eyeRect.height) / 2

      this.$set(this, "rightEyeOuter", {
        x: rightX, y,
        a: {x: rightX - minDim * defaultEyeOuterRadius, y},
        b: {x: rightX + minDim * defaultEyeOuterRadius, y},
      })

      this.$set(this, "rightEyeInner", {
        x: rightX, y,
      })

      this.$set(this, "leftEyeOuter", {
        x: leftX, y,
        a: {x: leftX - minDim * defaultEyeOuterRadius, y},
        b: {x: leftX + minDim * defaultEyeOuterRadius, y},
      })

      this.$set(this, "leftEyeInner", {
        x: leftX, y,
      })
    },
    click(e){
      this.mouse.click.x = e.offsetX
      this.mouse.click.y = e.offsetY
      this.move(e)
      this.mouse.down = true
    },
    up(e){
      this.mouse.down = false
      this.mouse.dragging = false
      this.dragHanlder = null
    },
    move(e){
      this.mouse.current.x = e.offsetX
      this.mouse.current.y = e.offsetY
      if(this.mouse.down){
        this.mouse.dragging = true
        if(this.dragHanlder){
          this.dragHanlder(this.mouse.current.x, this.mouse.current.y)
        }
      }
      e.preventDefault()
    },
    touchClick(e){
      let x = e.touches[0].pageX - this.canvasOffset.x
      let y = e.touches[0].pageY - this.canvasOffset.y
      this.mouse.click.x = x
      this.mouse.click.y = y
      this.touchMove(e)
      this.mouse.down = true
    },
    touchUp(e){
      this.mouse.down = false
      this.mouse.dragging = false
      this.dragHanlder = null
    },
    touchMove(e){
      let x = e.touches[0].pageX - this.canvasOffset.x
      let y = e.touches[0].pageY - this.canvasOffset.y
      this.mouse.current.x = x
      this.mouse.current.y = y
      if(this.mouse.down){
        this.mouse.dragging = true
        if(this.dragHanlder){
          this.dragHanlder(this.mouse.current.x, this.mouse.current.y)
        }
      }
      e.preventDefault()
    },
    wait(n){
      return new Promise((resolve, reject) => setTimeout(resolve, n))
    },
    back(){
      if(this.step === 0){
        this.$router.push({
          name: "select",
        })
      }
      this.step--
    },
    next(){
      this.step++ 
      if(this.step === this.steps){
        this.save()
      }
    },
    save(){
      let {width, height} = this.photo
      let compute = (outer, inner) => {
        let cx = outer.x * width
        let cy = outer.y * height
        let rx = outer.a.x * width
        let ry = outer.a.y * height
        let bx = inner.x * width
        let by = inner.y * height

        let output = {
          center: {x: cx, y: cy},
          radius: Math.sqrt(Math.pow(cx - rx, 2) + Math.pow(cy - ry, 2)),
          brilliance: {x: bx, y: by},
        }

        return output
      }
      let record = {
        id: this.id,
        name: this.name,
        date: new Date().toISOString(),

        photo: {
          source: this.photo,
          width, height,
        },
        rightEye: compute(this.rightEyeOuter, this.rightEyeInner),
        leftEye: compute(this.leftEyeOuter, this.leftEyeInner),
      }

      this.$store.commit('saveRecord', record)

      this.$router.push({
        name: "view",
        params: {
          id: this.id,
        },
      })
    },
  },
  async mounted(){
    if(!this.photo) this.$router.push({name: 'home'})
    this.ready = true
    this.canvas.addEventListener('mousedown', this.click)
    window.addEventListener('mouseup', this.up)
    this.canvas.addEventListener('mousemove', this.move)

  
    this.canvas.addEventListener('touchstart', this.touchClick)
    window.addEventListener('touchend', this.touchUp)
    this.canvas.addEventListener('touchmove', this.touchMove)

    this.setDefaultCircleSelections()
    this.loop()
  },
  computed: {
    canvas: {
      get(){
        if(!this.ready) return false
        return this.$refs.canvas || document.querySelector('#canvas')
      },
    },
    eyeRectNormalized(){
      let eyeRect = {
        x: Math.min(this.eyeRect.a.x, this.eyeRect.b.x),
        y: Math.min(this.eyeRect.a.y, this.eyeRect.b.y)
      }

      eyeRect.width = Math.max(this.eyeRect.a.x, this.eyeRect.b.x) - eyeRect.x
      eyeRect.height = Math.max(this.eyeRect.a.y, this.eyeRect.b.y) - eyeRect.y

      return eyeRect
    },
    context(){
      return this.canvas.getContext('2d')
    },
    photo(){
      return this.$store.state.photo
    },
    theme(){
      return this.$store.state.themes[this.$store.state.theme]
    },
    instructions(){
      let instructions = [
        "Draw a rectangle to select the eyes. Drag the corners to cover both eyes.",
        "Drag the circles to trace the outline of the limbus.",
        "Drag the circle to pinpoint the center of the brilliance.",
      ]
      instructions.push(instructions[1])
      instructions.push(instructions[2])
      return instructions[this.step]
    },
    canvasOffset(){
      let x = 0
      let y = 0

      let parent = this.canvas
      while(parent && parent.parentElement){
        x += parent.offsetLeft
        y += parent.offsetTop
        parent = parent.parentElement
      }

      return {x, y}
    },
  },
  beforeDestroy(){
    this.looping = false
    this.canvas.removeEventListener('mousedown', this.click)
    window.removeEventListener('mouseup', this.up)
    this.canvas.removeEventListener('mousemove', this.move)
    
    this.canvas.removeEventListener('touchstart', this.touchClick)
    window.removeEventListener('touchend', this.touchUp)
    this.canvas.removeEventListener('touchmove', this.touchMove)
  },
  watch: {
    
  },
}
</script>

<style scoped lang="sass">
@import ../sass/variables

.view-container
  padding: 0
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: center
  .canvas-container
    width: 100%
    flex-grow: 1
    flex-shrink: 1
    canvas
      position: absolute
      width: 100%
      height: 100%

  .interface-container
    width: 100%
    flex-grow: 0
    flex-grow: 0

    .content-container
      padding: 1.5em $margin-percent

      &.text-container
        padding-top: 2em
        .title
          margin-bottom: 0.25em

      &.buttons-container
        padding-bottom: 2em
        display: flex
        justify-content: space-between
        align-items: center

    .progress-bar
      width: 100%
      height: 0.5em
      background-color: var(--bg2)
      .bar
        transition: 0.2s all
        height: 100%
        background-color: var(--ac1)


</style>
